import {Item} from '@/types/Component';

export function isItem(arg: any): arg is Item {
    if (!arg) return false;
    return typeof arg === 'object'
        && Object.prototype.hasOwnProperty.call(arg, 'id')
        && Object.prototype.hasOwnProperty.call(arg, 'name')
}

export function isItemList(arg: any): arg is Item[] {
    return arg instanceof Array
        && isItem(arg[0])
}
